import * as types from './types'
import * as integration from '../../../integration'

export const receiveMenuList = (value) => ({
  type: types.RECEIVE_MENU_LIST,
  payload: value
})

export const fetchMenuList = (payload = true) => ({
  type: types.FETCH_MENU_LIST,
  payload
})

export const getSidebarMenu = () => async (dispatch) => {
  dispatch(fetchMenuList())

  try {
    const res = await integration.resources.menu.requests.getMenuResource()

    dispatch(receiveMenuList(res))
  } catch (err) {
    dispatch(fetchMenuList(false))
  }
}
